import React from "react";
import { ServicesController } from "@/app/core/base/controllers/ServicesController";
import { MoneyMask } from "@/app/core/util/helpers/MoneyHelper";
import { ServiceHelper } from "@/app/core/util/helpers/ServiceHelper";

export default function ServiceCard({ data, reload, onEdit }) {
    const handleDelete = async () => {
        if (window.confirm("Tem certeza de que deseja excluir este serviço?")) {
            await ServicesController.Delete(data.id);
            reload();
        }
    };

    const formatDate = (timestamp) => {
        const date = new Date(timestamp.seconds * 1000);
        return date.toLocaleDateString('pt-BR', {
            timeZone: 'America/Sao_Paulo'
        });
    };
    return (
        <div className="card" style={{ border: "1px solid #ccc", borderRadius: "5px", padding: "10px", margin: "10px 0" }}>
            <div className="card-body">
                <h5 className="card-title">{data.name}</h5>
                <div className="card-text">{data.description}</div>
                <div className="card-text">Preço: {data.price && MoneyMask(data.price)}</div>
                <div className="card-text">Status: {data.status === ServiceHelper.Status.Active ? "Ativo" : "Inativo"}</div>
                <div className="card-text">Criado em: {formatDate(data.createdDate)}</div>
                <div className="card-text">Atualizado em: {formatDate(data.updatedDate)}</div>
                <button className="btn btn-warning" onClick={onEdit}>Editar</button>
                <button className="btn btn-danger" onClick={handleDelete}>Excluir</button>
            </div>
        </div>
    );
}
